export default {
  name: 'CalculationForm',
  props: {
    index: Number,
    item: Object,
  },
  data() {
    return {
      searchProducts: '',
      products: [],
      loading: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        requiredNumber: value => value > 0 || 'Поле должно быть заполнено',
      },
    };
  },
  watch: {
    'item.product': 'updateItem',
    searchProducts(val) {
      if (!val) {
        this.products = [];
        return;
      }
      this.loading = true;
      this.$store.getters.axl.post('design/api/account/autocomplete-products', { term: val })
        .then((result) => {
          this.products = result.data.products;
          this.loading = false;
        });
    },
  },
  methods: {
    updateItem(value) {
      if (value) {
        this.$emit('updateItem', { index: this.index, value });
      }
    },
    addItem() {
      this.$emit('addItem');
    },
    removeItem() {
      this.$emit('removeItem', this.index);
    },
  },
};
